import dayjs from 'dayjs';

const diffTz = 0;
export const toReadableDateTimeString = (date) => {
  if (!date) return;
  const tzTime = dayjs(date).subtract(diffTz, 'hours');
  return tzTime.format('DD/MM/YYYY HH:mm');
};

export const toReadableDateString = (date) => {
  if (!date) return;
  const tzTime = dayjs(date).subtract(diffTz, 'hours');

  return tzTime.format('DD/MM/YYYY');
};

export const toSummaryBirthDate = (date) => {
  if (!date) return;

  return dayjs(date).format('DD/MM/YYYY');
};

export const toDateRange = (start, end) => {
  if (!start || !end) return 'TBA';

  const tzStart = dayjs(start).subtract(diffTz, 'hours');
  const tzEnd = dayjs(end).subtract(diffTz, 'hours');

  const startDate = tzStart.format('DD-MMMM-YYYY').split('-');
  const endDate = tzEnd.format('DD-MMMM-YYYY').split('-');
  const yearNow = dayjs().get('year');

  let result = `${startDate[0]}-${endDate[0]} ${startDate[1]}`;

  if (startDate[1] !== endDate[1]) {
    result = `${startDate[0]} ${startDate[1]}-${endDate[0]} ${endDate[1]}`;
  }

  if (
    startDate[2] !== endDate[2] ||
    startDate[2] !== yearNow.toString() ||
    endDate[2] !== yearNow.toString()
  ) {
    result = `${startDate[0]} ${startDate[1]} ${startDate[2]}-${endDate[0]} ${endDate[1]} ${endDate[2]}`;
  }

  if (
    startDate[0] === endDate[0] &&
    startDate[1] === endDate[1] &&
    startDate[2] === endDate[2]
  ) {
    result = `${startDate[0]} ${startDate[1]} ${startDate[2]}`;
  }
  return result;
};

export const toTimeRange = (start, end, eId) => {
  if (!start || !end) return 'TBA';

  const tzStart = dayjs(start).subtract(diffTz, 'hours');
  const tzEnd = dayjs(end).subtract(diffTz, 'hours');

  const startTime = tzStart.format('HH:mm');
  const endTime = tzEnd.format('HH:mm');

  if (eId && eId === 100) return `${startTime} WIB`;

  return `${startTime}-${endTime} WIB`;
};

export const toSQLFormat = (date) => {
  if (!date) return;

  const tzDate = dayjs(date).subtract(diffTz, 'hours');

  return tzDate.format('MM/DD/YYYY');
};
